/* This file is autogenerated, see readme.md for instructions */
import DivideSvgIcon from '@bloomreach/banana-theme/icons/divide.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const DivideIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <DivideSvgIcon />
    </Icon>
  );
});

DivideIcon.displayName = 'DivideIcon';

export default DivideIcon;
